// CSV files staff open in Excel or Numbers (CMS review rania-37,
// georges-35): the Cases list, Customers, Money and the Activity log export
// what is on screen with its filters. Values are quoted as RFC 4180 asks,
// and a value that starts like a formula (= + - @) gets a leading
// apostrophe so a spreadsheet shows it as text instead of running it.
const RISKY = /^[=+\-@\t\r]/;

export function csvValue(value) {
  if (value === null || value === undefined) return "";
  let text = String(value);
  if (RISKY.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) || text !== text.trim() ? `"${text.replace(/"/g, '""')}"` : text;
}

// columns: [{ label, value: (row) => any }]
export function toCsv(rows, columns) {
  const lines = [columns.map((c) => csvValue(c.label)).join(",")];
  for (const row of rows) lines.push(columns.map((c) => csvValue(c.value(row))).join(","));
  return `${lines.join("\r\n")}\r\n`;
}

// Saves the text as a file. The byte-order mark makes Excel read the
// accents and Arabic letters right.
export function downloadCsv(filename, text) {
  const blob = new Blob(["﻿", text], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

const pad = (n) => String(n).padStart(2, "0");
// "2026-10-29": a date for a spreadsheet, on this computer's calendar.
export function isoDay(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? "" : `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// "cases-needs-action-2026-10-29.csv"
export const csvName = (...parts) =>
  `${parts
    .filter(Boolean)
    .map((p) => String(p).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""))
    .join("-")}-${isoDay(new Date())}.csv`;
